import React from 'react';

/**
 * 선 아이콘 세트 — 24×24, stroke 1.8. 외부 아이콘 폰트에 의존하지 않는다.
 *   <Icon name="search" size={18} />
 */
const PATHS = {
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-3.5-3.5',
  bag: 'M6 8h12l1 12H5L6 8zM9 8V6a3 3 0 0 1 6 0v2',
  bell: 'M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15L6 16zM10 20a2 2 0 0 0 4 0',
  menu: 'M4 7h16M4 12h16M4 17h16',
  x: 'M6 6l12 12M18 6L6 18',
  chevronDown: 'M6 9l6 6 6-6',
  chevronUp: 'M6 15l6-6 6 6',
  chevronRight: 'M9 6l6 6-6 6',
  chevronLeft: 'M15 6l-6 6 6 6',
  chevronsLeft: 'M11 6l-6 6 6 6M18 6l-6 6 6 6',
  chevronsRight: 'M6 6l6 6-6 6M13 6l6 6-6 6',
  arrowRight: 'M5 12h14M13 6l6 6-6 6',
  arrowLeft: 'M19 12H5M11 6l-6 6 6 6',
  arrowUp: 'M12 19V5M6 11l6-6 6 6',
  arrowUpRight: 'M7 17L17 7M8 7h9v9',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 20a8 8 0 0 1 16 0',
  logout: 'M10 4H5v16h5M14 8l4 4-4 4M18 12H9',
  upload: 'M12 16V5M7 10l5-5 5 5M4 19h16',
  download: 'M12 4v11M7 10l5 5 5-5M4 19h16',
  file: 'M7 3h7l5 5v13H7V3zM14 3v5h5',
  fileText: 'M7 3h7l5 5v13H7V3zM14 3v5h5M10 12h6M10 16h6',
  eye: 'M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  eyeOff: 'M3 3l18 18M10 6.3A10 10 0 0 1 12 6c6.5 0 10 6 10 6a17 17 0 0 1-3.2 3.7M6.6 6.6C3.7 8.5 2 12 2 12s3.5 6 10 6a9.7 9.7 0 0 0 4-.9M9.9 9.9a3 3 0 0 0 4.2 4.2',
  check: 'M5 12l5 5L20 7',
  checkCircle: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8 12l3 3 5-6',
  alert: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 8v5M12 16v.5',
  alertTri: 'M12 4l9 16H3l9-16zM12 10v4M12 17v.5',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v6M12 8v.5',
  mail: 'M4 6h16v12H4V6zM4 7l8 6 8-6',
  phone: 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z',
  mapPin: 'M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2',
  layers: 'M12 3l9 5-9 5-9-5 9-5zM3 13l9 5 9-5M3 17l9 5 9-5',
  box: 'M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3zM12 12l8-4.5M12 12v9M12 12L4 7.5',
  truck: 'M2 6h11v10H2V6zM13 10h5l3 3v3h-8v-6zM6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3zM9 12l2 2 4-4',
  grid: 'M4 4h7v7H4V4zM13 4h7v7h-7V4zM4 13h7v7H4v-7zM13 13h7v7h-7v-7z',
  image: 'M4 5h16v14H4V5zM4 16l4.5-4.5 3.5 3.5 2.5-2.5L20 17M8.5 9.5h.01',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19 12a7 7 0 0 0-.1-1l2-1.5-2-3.5-2.3 1a7 7 0 0 0-1.7-1L14.5 3h-5l-.4 2.5a7 7 0 0 0-1.7 1l-2.3-1-2 3.5 2 1.5a7 7 0 0 0 0 2l-2 1.5 2 3.5 2.3-1a7 7 0 0 0 1.7 1l.4 2.5h5l.4-2.5a7 7 0 0 0 1.7-1l2.3 1 2-3.5-2-1.5c.1-.3.1-.7.1-1z',
  lock: 'M6 11h12v10H6V11zM8 11V8a4 4 0 0 1 8 0v3',
  external: 'M14 4h6v6M20 4l-9 9M18 13v7H4V6h7',
  refresh: 'M20 12a8 8 0 1 1-2.3-5.7M20 4v5h-5',
  filter: 'M3 5h18l-7 8v6l-4 2v-8L3 5z',
  calendar: 'M4 6h16v14H4V6zM4 10h16M8 3v4M16 3v4',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  trash: 'M5 7h14M9 7V4h6v3M7 7l1 13h8l1-13M10 11v6M14 11v6',
  edit: 'M4 20h4l10-10-4-4L4 16v4zM13 7l4 4',
  message: 'M4 5h16v11H9l-5 4V5z',
  star: 'M12 3l2.8 6 6.2.8-4.5 4.3 1.1 6.4L12 17.5 6.4 20.5l1.1-6.4L3 9.8 9.2 9 12 3z',
  zap: 'M13 2L4 14h7l-1 8 9-12h-7l1-8z',
  home: 'M4 11l8-7 8 7v9h-5v-6h-6v6H4v-9z',
  package: 'M4 8l8-4 8 4v9l-8 4-8-4V8zM4 8l8 4 8-4M12 12v9',
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  cut: 'M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM20 4L8.1 15.9M14.5 14.5L20 20M8.1 8.1L12 12',
  ruler: 'M3 17L17 3l4 4L7 21l-4-4zM8 12l2 2M11 9l2 2M14 6l2 2',
  send: 'M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z',
  copy: 'M8 8h12v12H8V8zM4 16V4h12',
  hash: 'M4 9h16M4 15h16M10 3l-2 18M16 3l-2 18',
  dollar: 'M12 2v20M17 6.5C16 5 14.5 4.5 12 4.5S7.5 6 7.5 8s2 3.5 4.5 3.5 4.5 1.5 4.5 3.5-2 3.5-4.5 3.5-5-1-6-2.5',
  help: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .9-1 1.7M12 17v.5',
  sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3zM19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8L19 16z',
  moreH: 'M6 12h.01M12 12h.01M18 12h.01',
  inbox: 'M4 4h16v16H4V4zM4 14h5l1.5 2h3L15 14h5'
};

export default function Icon({ name, size = 18, strokeWidth = 1.8, className = '', style, ...rest }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={d} />
    </svg>
  );
}

export const ICON_NAMES = Object.keys(PATHS);
